import { applyThousandSeparator } from 'ui-library/components/NumberInput/utils';
import { defaultPieChartOptions } from './constants';

export const getSum = (data: Array<{ value: number }>) => (data.length > 0
    ? data.map((item) => item.value).reduce((sum, i) => sum + i)
    : 0);

const sortChartsArray = (data: Array<{ value: number }>) => [...data].sort((a, b) => b.value - a.value);

export const buildDataArray = (data: any[]) => data.map(({
    name, value, percent, ...rest
}) => ({
    name, y: value, percent, ...rest,
}));

export const buildAdditionalCss = (data: any[], index?: number) => data.reduce(
    (acc, { color }, idx) => ({ ...acc, [`--pie-chart-colors-${index || idx}`]: color }), {},
);

export const buildSingleDataArrays = (data: any[], sum: number) => data.map(({
    name, value, percent, color,
}) => [{
    name, y: value, percent, color,
}, { name: '', y: sum - value, color }]);

export const getPieChartOptions = (data: any[], sum: number, singleAllocation: boolean, percentFormat: (value: number) => string, chartSize: number, showCHFValue = false) => {
    const subtitleText = `${singleAllocation
        ? `${percentFormat(data[0].percent || (data[0].y / sum) * 100)}`
        : ''}`;

    function formatter(this: any) {
        return `<div style="text-align: center;">
                    ${showCHFValue ? `<div style="color: #142966; font-size: 12px; font-weight:600"><strong>CHF ${this.point.y ? applyThousandSeparator(`${this.point.y?.toFixed(2)}`, "’") : '0.00'}</strong></div>` : `<div style="color: #142966; font-size: 12px; font-weight:500">${this.point.name || 'Other'}</div>`}
                    <div style="font-weight:400">${percentFormat(this.point.percentage)}</div>
                </div>`;
    }

    const chartSizeOptions = chartSize ? { height: chartSize, width: chartSize } : {};

    return {
        ...defaultPieChartOptions,
        chart: {...defaultPieChartOptions.chart, ...chartSizeOptions},
        subtitle: { ...defaultPieChartOptions.subtitle, text: subtitleText },
        tooltip: { ...defaultPieChartOptions.tooltip, formatter },
        series: [{ ...defaultPieChartOptions.series[0], data }],
        lang: {
            sanitize: function (html: string) {
                return html.replace(
                    /\b(href|src)=["']?(javascript|data|vbscript):/gi,
                    '$1="#"'
                );
            }
        }
    };
};

export const buildLegend = (data: any[], sum: number, singleAllocation: boolean, percentFormat: (value: number) => string) => {
    const getPercent = (value, percent) => percentFormat(percent
            || (Math.round((value / sum) * 10000) / 100));

    return data.filter(({ name }) => name)
        .map(({ name, y, percent }) => ({
            label: name,
            percent: singleAllocation ? undefined : getPercent(y, percent),
            value: y,
        }));
};

export const adaptDataPieChart = (data: any[], maxItems: number) => {
    const sortArray = (data);

    if (data.length <= maxItems) {
        return sortArray;
    }

    const other = sortArray.slice(maxItems - 1);

    const otherValue = other.reduce((acc, item) => {
        if (Object.prototype.hasOwnProperty.call(item, 'percent')) {
            return {
                ...acc,
                value: acc.value + item.value,
                percent: acc?.percent
                    ? +parseFloat(acc?.percent + item.percent).toFixed(1) : item.percent,
            };
        }
        acc.value += item.value;

        return acc;
    }, { value: 0 });

    return [...sortArray.slice(0, maxItems - 1), { name: 'Other', ...otherValue }];
};
